import PublicAPI from '@/api/TreedisPublicDAO';

export const getFloorPlans = async (id: number) => {
  const res = await PublicAPI.getFloorPlans({ id });

  return res?.floorPlans || [];
};

export const getDuplicates = async (id: number) => {
  const res = await PublicAPI.getDuplicates(id);
  return res?.duplicates || [];
};

export const getSweeps = async (matterId: string, slug: string) => {
  if (!matterId) return [];

  const res = await PublicAPI.getSweeps({
    matterId,
    slug,
  });

  return res?.sweeps || [];
};
